var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.143 7.043c.362 0 .62.226.665.566l.006.105V16.4c0 .864-.707 1.617-1.557 1.694l-.143.006H5.886c-.865 0-1.617-.707-1.694-1.557l-.006-.143V7.714c0-.398.273-.671.671-.671.362 0 .62.226.665.566l.007.105V16.4c0 .152.14.311.292.349l.065.008h8.228c.152 0 .312-.14.35-.292l.007-.065V7.714c0-.398.274-.671.672-.671zm2.286-2.286c.34 0 .671.33.671.672 0 .31-.273.61-.579.663l-.092.008H2.57c-.34 0-.671-.33-.671-.671 0-.31.273-.612.579-.664l.092-.008H17.43zM12.857 1.9c.341 0 .672.33.672.671 0 .31-.274.612-.58.664l-.092.008H7.143c-.341 0-.672-.33-.672-.672 0-.31.274-.61.58-.663l.092-.008h5.714z",
    fill: "#091A32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.877 7.274c.579-.193.723-.101.837.012a.624.624 0 01.193.428h0V14a.624.624 0 01-.193.428.624.624 0 01-.428.193.624.624 0 01-.429-.193.624.624 0 01-.193-.428h0V7.714a7.97 7.97 0 01.202-.436l.011-.004zm3.429 0c.578-.193.723-.101.836.012a.624.624 0 01.194.428h0V14a.624.624 0 01-.193.428.624.624 0 01-.429.193.624.624 0 01-.428-.193.624.624 0 01-.193-.428h0V7.714c.196-.43.199-.434.202-.436l.01-.004z",
    stroke: "#3B65EE",
    strokeWidth: 0.1,
    fill: "#3B65EE"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/assets/delete.50ec4b4c.svg";
export { ForwardRef as ReactComponent };